export default __webpack_public_path__ + "static/media/grapefruit-carousel-headline-box@2x.f304eb90.png";